import { useCallback, useState } from "react";

const isBoardFeatureMode = (mode) =>
  mode === "events" || mode === "announcements";

const normalizeBoardCategories = (payload, mode) => {
  const data = payload?.data || payload;
  const value =
    data?.category ??
    data?.categories ??
    (mode === "announcements" ? data?.type ?? data?.notice_type : undefined);
  const categories = Array.isArray(value)
    ? value
    : typeof value === "string"
      ? value.split("\n")
      : [];

  return Array.from(
    new Set(
      categories
        .map((category) => String(category || "").trim())
        .filter(Boolean)
    )
  );
};

const useBoardCategoryFilter = (mode) => {
  const isBoardMode = isBoardFeatureMode(mode);
  const [categoryState, setCategoryState] = useState({
    mode,
    values: [],
  });
  const [selection, setSelection] = useState({
    mode,
    value: "",
  });
  const categories = categoryState.mode === mode ? categoryState.values : [];
  const activeCategory = selection.mode === mode ? selection.value : "";

  const buildRequestParams = useCallback(
    (page, limit) => {
      const params = {
        page,
        limit,
        order_by_name: isBoardMode ? "sequence" : "created_at",
        order_by_type: isBoardMode ? "ASC" : "DESC",
      };

      if (isBoardMode && activeCategory) {
        params[mode === "announcements" ? "type" : "category"] =
          activeCategory;
      }

      return params;
    },
    [activeCategory, isBoardMode, mode]
  );

  const captureCategories = useCallback(
    (payload) => {
      if (!isBoardMode) return;
      setCategoryState({
        mode,
        values: normalizeBoardCategories(payload, mode),
      });
    },
    [isBoardMode, mode]
  );

  const selectCategory = useCallback(
    (value) => {
      setSelection({
        mode,
        value,
      });
    },
    [mode]
  );

  return {
    activeCategory,
    buildRequestParams,
    captureCategories,
    categories,
    isBoardMode,
    selectCategory,
  };
};

export default useBoardCategoryFilter;
